export default __webpack_public_path__ + "static/media/faraj.464132f5.jpeg";